import React from 'react';
import PropTypes from 'prop-types';
import { copyDistrict } from '../../api/districtapi';

export function DistrictCopyModal({ show, onClose, model = {}, onUpdate }) {
    const handleCopyConfirm = () => {
        if (model?.id) {
            copyDistrict(model?.id).then(() => {
                onUpdate();
                onClose();
            });
        }
    };

    if (!show) return null;

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal" role="dialog" aria-modal="true">
                <h2 className="admin-modal-heading">
                    Are you sure you want to make a copy of the district &quot;{model.name}&quot;?
                </h2>
                <div className="admin-modal-row full">
                    <div className="admin-modal-cell">{model.name}</div>
                </div>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button red" onClick={handleCopyConfirm}>
                        Copy District
                    </button>
                    <button className="admin-modal-button" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

DistrictCopyModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    model: PropTypes.shape({
        name: PropTypes.string,
    }),
    onUpdate: PropTypes.func.isRequired,
};

DistrictCopyModal.defaultProps = {
    model: {},
};
